import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack } from '@mui/material';
import { useStyles } from '../styles/headerStyles';
import BreadCrumb from '../../../../components/breadcrumb/BreadCrumbNavigation';
import Iconify from '../../../../components/iconify';
import { isAdmin } from '../../../../utils/share';
import { PROJECT_EDITOR_ROLE, ROLE_CAN_REMOVE_PROJECT } from '../../../../Constants/ProjectConstants';

const Header = ({ id, status, name, userRole, isEditable, onToggleEditBtn, onDeleteClick }) => {
  const classes = useStyles();
  return (
    <BreadCrumb status={status} name={name} pageName="Settings" id={id}>
      {isAdmin() || PROJECT_EDITOR_ROLE.includes(userRole?.roleName) ? (
        <Stack direction="column" item className={classes.buttons}>
          {isEditable ? (
            <Button
              variant="contained"
              color="error"
              onClick={onToggleEditBtn}
              className={classes.actionButton}
              startIcon={<Iconify icon={'bi:x-circle-fill'} sx={{ mr: 2 }} />}
            >
              Cancel
            </Button>
          ) : (
            <Button
              variant="contained"
              className={classes.actionButton}
              onClick={onToggleEditBtn}
              startIcon={<Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />}
            >
              Edit
            </Button>
          )}
          {isAdmin() || ROLE_CAN_REMOVE_PROJECT.includes(userRole?.roleName) ? (
            <Button
              variant="contained"
              color="error"
              onClick={onDeleteClick}
              startIcon={<Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />}
            >
              Delete
            </Button>
          ) : null}
        </Stack>
      ) : null}
    </BreadCrumb>
  );
};

Header.propTypes = {
  id: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  userRole: PropTypes.object,
  isEditable: PropTypes.bool,
  onToggleEditBtn: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default Header;
